import React from 'react';
import { Routes, Route } from 'react-router-dom';

import InterviewPage from '../InterviewPage';
import RedirectToNextPage from '../RedirectToNextPage';

export const InterviewRouter: React.FC = () => (
  <Routes>
    <Route path=":shortInterviewURN" element={<RedirectToNextPage />} />
    <Route path=":shortInterviewURN/:shortSectionURN" element={<InterviewPage />} />
  </Routes>
);

export default InterviewRouter;
